import React, { useState } from 'react';
import { Bot, ChevronDown, ChevronUp, Send, X } from 'lucide-react';
export function AiAssistant() {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([{
    id: 1,
    type: 'assistant',
    content: "Hello! I'm Vino, your TTB compliance assistant. How can I help with your wine label today?",
    time: '10:30 AM'
  }]);
  const quickQuestions = ['What are the TTB requirements for alcohol content?', 'Do I need to include sulfite warnings?', 'What appellation requirements apply?', 'Check my vintage year compliance'];
  const handleSend = () => {
    if (!message.trim()) return;
    // Add user message
    const newMessage = {
      id: messages.length + 1,
      type: 'user',
      content: message,
      time: new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      })
    };
    setMessages([...messages, newMessage]);
    setMessage('');
    // Simulate AI response
    setTimeout(() => {
      const aiResponse = {
        id: messages.length + 2,
        type: 'assistant',
        content: 'Based on TTB regulations, wine labels must include: brand name, class/type, alcohol content, net contents, sulfite declaration, and country of origin. Your current label is missing the sulfite declaration. Would you like me to suggest appropriate wording?',
        time: new Date().toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        })
      };
      setMessages(prev => [...prev, aiResponse]);
    }, 1000);
  };
  if (!isOpen) {
    return <button onClick={() => setIsOpen(true)} className="fixed bottom-6 right-6 bg-purple-700 text-white p-4 rounded-full shadow-lg hover:bg-purple-800 transition-all duration-200 z-50" data-id="element-5">
        <Bot className="w-6 h-6" data-id="element-6" />
      </button>;
  }
  return <div className="fixed bottom-6 right-6 w-80 bg-white rounded-lg shadow-xl border border-gray-200 overflow-hidden z-50 transition-all duration-300" data-id="element-7">
      {/* Header */}
      <div className="bg-purple-700 text-white p-3 flex justify-between items-center" data-id="element-8">
        <div className="flex items-center space-x-2" data-id="element-9">
          <Bot className="w-5 h-5" data-id="element-10" />
          <h3 className="font-medium" data-id="element-11">Vino - TTB Assistant</h3>
        </div>
        <div className="flex items-center space-x-1" data-id="element-12">
          <button onClick={() => setIsMinimized(!isMinimized)} className="p-1 hover:bg-[#8B3A45] rounded" data-id="element-13">
            {isMinimized ? <ChevronUp className="w-4 h-4" data-id="element-14" /> : <ChevronDown className="w-4 h-4" data-id="element-15" />}
          </button>
          <button onClick={() => setIsOpen(false)} className="p-1 hover:bg-[#8B3A45] rounded" data-id="element-16">
            <X className="w-4 h-4" data-id="element-17" />
          </button>
        </div>
      </div>
      {/* Body - only show if not minimized */}
      {!isMinimized && <>
          {/* Messages */}
          <div className="h-64 overflow-y-auto p-3 space-y-3 bg-gray-50" data-id="element-18">
            {messages.map(msg => <div key={msg.id} className={`flex ${msg.type === 'user' ? 'justify-end' : 'justify-start'}`} data-id="element-19">
                <div className={`max-w-[85%] p-3 rounded-lg text-sm ${msg.type === 'user' ? 'bg-[#722F37] text-white' : 'bg-gray-200 text-gray-900'}`} data-id="element-20">
                  <p data-id="element-21">{msg.content}</p>
                  <p className={`text-xs mt-1 ${msg.type === 'user' ? 'text-[#E8C8CC]' : 'text-gray-500'}`} data-id="element-22">
                    {msg.time}
                  </p>
                </div>
              </div>)}
          </div>
          {/* Quick Questions */}
          <div className="p-3 border-t border-gray-200 bg-gray-50" data-id="element-23">
            <p className="text-xs font-medium text-gray-700 mb-2" data-id="element-24">
              Quick Questions:
            </p>
            <div className="grid grid-cols-2 gap-2" data-id="element-25">
              {quickQuestions.map((q, i) => <button key={i} onClick={() => {
            setMessage(q);
          }} className="p-2 text-xs text-left text-[#722F37] hover:text-[#8B3A45] bg-[#F9E6E9] hover:bg-[#F4D6DA] rounded border border-[#E8C8CC] transition-colors truncate" data-id="element-26">
                  {q}
                </button>)}
            </div>
          </div>
          {/* Input */}
          <div className="p-3 border-t border-gray-200" data-id="element-27">
            <div className="flex space-x-2" data-id="element-28">
              <input type="text" value={message} onChange={e => setMessage(e.target.value)} onKeyPress={e => e.key === 'Enter' && handleSend()} placeholder="Ask about TTB compliance..." className="flex-1 p-2 text-sm border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#722F37]" data-id="element-29" />
              <button onClick={handleSend} className="bg-[#722F37] text-white p-2 rounded hover:bg-[#8B3A45]" data-id="element-30">
                <Send className="w-4 h-4" data-id="element-31" />
              </button>
            </div>
          </div>
        </>}
    </div>;
}